import React, { Component } from 'react';
import { Divider, Grid, Progress } from 'semantic-ui-react';

export default class Programming extends Component {
    state = {
        skills: [
            {   
                name: 'Back-end skills',
                languages: [{
                    name: 'Python',
                    progress: 85,
                }, {
                    name: 'Django',
                    progress: 80,
                }, {
                    name: 'Node',
                    progress: 50
                }, {
                    name: 'Golang',
                    progress: 55
                }]
            }, {   
                name: 'Front-end skills',
                languages: [{
                    name: 'JavaScript',
                    progress: 85,
                }, {
                    name: 'HTML/CSS',
                    progress: 85
                }, {
                    name: 'React',
                    progress: 75
                }, {
                    name: 'Redux',
                    progress: 70
                }]
            }, {   
                name: 'Cloud',
                languages: [{
                    name: 'Amazon Web Services',
                    progress: 60,
                }, {
                    name: 'Google Cloud Platform',
                    progress: 50
                }]
            }
        ]
    }
    render() {
        const { skills } = this.state;
        return skills.map((area, key) => {
            return (
                <Grid.Column key={key} widescreen={8} largeScreen={8} computer={8} tablet={16} mobile={16}>
                <h3>{area.name}</h3>
                    {(() => {
                        return area.languages.map((language, key) => {
                            return (
                                <div style={{ marginBottom: 10 }} key={key}>
                                    <strong>{language.name}</strong>
                                    <Divider hidden fitted />
                                    <Progress style={{ width: '80%' }} percent={language.progress} size={"tiny"} color={"blue"} />
                                </div>
                            );
                        });
                    })()}
                </Grid.Column>
            );
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/Programming.js